import { useState } from 'react';
import axios from 'axios';
import ReactMarkdown from 'react-markdown';

const BotEpic = ({ onClose, setLoading }) => {
  const [question, setQuestion] = useState('');
  const [answer, setAnswer] = useState('');

  const handleAsk = async () => {
    if (!question.trim()) return;
    setLoading(true);
    setAnswer('');

    try {
      const response = await axios.post('http://localhost:4000/api/v1/chatbot', {
        question,
      });
      setAnswer(response.data.answer || '');
    } catch (err) {
      setAnswer('⚠️ Ups... algo salió mal.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="bg-white w-80 p-4 rounded-2xl shadow-2xl border border-yellow-400">
      <div className="flex justify-between items-center mb-2">
        <span className="font-bold text-gray-800">🎬 EpicBot</span>
        <button
          onClick={onClose}
          className="text-sm text-gray-500 hover:text-red-400"
        >
          ✖
        </button>
      </div>

      <div className="mb-2 text-sm text-gray-700 whitespace-pre-wrap">
        {answer ? (
          <ReactMarkdown>{String(answer)}</ReactMarkdown>
        ) : (
          <p>¡Preguntame algo sobre cine!</p>
        )}
      </div>

      <input
        type="text"
        className="border border-gray-300 text-gray-900 rounded px-3 py-2 w-full text-sm mb-2 focus:outline-none focus:ring focus:ring-yellow-300"
        placeholder="¿Quién dirigió Matrix?"
        value={question}
        onChange={(e) => setQuestion(e.target.value)}
        onKeyDown={(e) => e.key === 'Enter' && handleAsk()}
      />

      <button
        onClick={handleAsk}
        className="w-full bg-yellow-500 text-white font-semibold py-1.5 rounded hover:bg-yellow-600 transition"
      >
        Preguntar
      </button>
    </div>
  );
};

export default BotEpic;
